import { createContext } from 'react';

import {
  UbiquitiApiDataItem,
  UbiquitiWifiBroadcast,
} from '@totem/components/ubiquiti/types';

interface Context {
  loading: boolean;
  error: boolean;
  wifiBroadcasts: UbiquitiApiDataItem<UbiquitiWifiBroadcast>[];
}

export default createContext<Context>({
  loading: false,
  error: false,
  wifiBroadcasts: [],
});
